export default __webpack_public_path__ + "static/media/question.a5794e68.svg";